import IconButton from "@mui/material/IconButton";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import Tooltip from "@mui/material/Tooltip";
import { ButtonProps } from "@mui/material/Button";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Slide from "@mui/material/Slide";
import { map } from "lodash";
import { useCallback, useMemo, useState } from "react";
import { Dialog } from "../../../components/Dialog";
import { Fields, Form } from "../../../types/forms";
import { useStyles } from "../styles";
import { FormAnswers } from "../../../components/FormAnswers";

type AnswersFormProps = {
  data: Form | null;
  open: boolean;
  onClose: () => void;
};

export function Answers({ data, open, onClose }: AnswersFormProps) {
  const [field, setField] = useState<Fields | null>(null);

  const styles = useStyles();

  const handleClose = useCallback(() => {
    setField(null);
    onClose();
  }, [onClose]);

  const handleCurrentField = useCallback((item: Fields) => {
    setField(item);
  }, []);

  const handleBack = useCallback(() => {
    setField(null);
  }, []);

  const RenderSecondaryActions = (props: any) => {
    return (
      <Tooltip placement="left-start" title="Ver respostas">
        <IconButton
          onClick={() => {
            handleCurrentField(props);
          }}
          edge="end"
          aria-label="keyboard-arrow-right"
        >
          <KeyboardArrowRight />
        </IconButton>
      </Tooltip>
    );
  };

  const actions: ButtonProps[] = useMemo(() => {
    return [
      {
        children: "Fechar",
        onClick: handleClose,
      },
    ];
  }, [handleClose]);

  const translateInputType = useMemo(() => {
    return {
      text: "Resposta curta",
      textarea: "Parágrafo",
      select: "Lista suspena",
      date: "Data",
      yesOrNo: "Sim ou Não",
    };
  }, []);

  const RenderItem = (item: Fields) => {
    return (
      <ListItem
        secondaryAction={<RenderSecondaryActions {...item} />}
        dense
        key={item.id_form_campo?.toString()}
      >
        <ListItemText
          primary={item.label}
          //@ts-ignore
          secondary={translateInputType[item.inputType as string]}
        />
      </ListItem>
    );
  };

  const RenderTitle = () => {
    return (
      <>
        {field && (
          <IconButton
            onClick={handleBack}
            edge="start"
            aria-label="keyboard-arrow-left"
          >
            <KeyboardArrowLeft />
          </IconButton>
        )}
        &nbsp;{data?.nameForm}
      </>
    );
  };

  return (
    <Dialog
      onClose={handleClose}
      fullWidth
      maxWidth="md"
      //@ts-ignore
      title={<RenderTitle />}
      open={open}
      actions={actions}
    >
      <div className={styles.rootContentRow}>
        <Slide
          style={{ width: "100%" }}
          direction="right"
          in={!Boolean(field)}
          mountOnEnter
          unmountOnExit
        >
          <List dense sx={{ width: "100%", bgcolor: "background.paper" }}>
            {map(data?.fields, (field) => RenderItem(field))}
          </List>
        </Slide>
        <Slide
          style={{ width: "100%" }}
          direction="left"
          in={Boolean(field)}
          mountOnEnter
          unmountOnExit
        >
          <div>
            <FormAnswers
              idForm={data?.id_formulario as number}
              idField={field?.id_form_campo as number}
            />
          </div>
        </Slide>
      </div>
    </Dialog>
  );
}
